import { useEffect, useRef } from "react";
import { useLocation } from "@/lib/router-compat";
import { supabase } from "@/integrations/supabase/client";
import { useAppStore } from "@/store/appStore";

const SESSION_KEY = "ll_session_id";

const getSessionId = () => {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id =
        typeof crypto !== "undefined" && "randomUUID" in crypto
          ? crypto.randomUUID()
          : Math.random().toString(36).slice(2) + Date.now().toString(36);
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
};

export const usePageView = () => {
  const location = useLocation();
  const session = useAppStore((s) => s.session);
  const userId = session?.user?.id ?? null;
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    const path = location.pathname;
    // Skip admin pages from analytics noise
    if (path.startsWith("/admin")) return;
    if (lastPath.current === path) return;
    lastPath.current = path;

    const t = setTimeout(() => {
      supabase
        .from("page_views")
        .insert({
          path,
          session_id: getSessionId(),
          user_id: userId,
          referrer: document.referrer || null,
          user_agent: navigator.userAgent || null,
        })
        .then(() => {});
    }, 300);

    return () => clearTimeout(t);
  }, [location.pathname, userId]);
};
